<template>
  <div>
    <el-dialog
      top="3vh"
      width="1050px"
      center
      :title="`卡主号：「${orderCheckObj.username}」／ 银行卡：「${
        orderCheckObj.bankCardNumber || ''
      }」的查单 ( ${orderCheckObj.id} )`"
      :visible="orderCheckObj.visible"
      @close="HandleCancel()"
    >
      <div class="table-container">
        <el-row :gutter="20">
          <!-- 支付查单列表 -->
          <el-col :span="12">
            <el-tag class="tag-title" size="medium" type="danger" effect="dark"
              >支付</el-tag
            >
            <el-table
              border
              stripe
              ref="table"
              v-loading="payTableLoading"
              element-loading-background="rgba(255, 255, 255, 0.8)"
              element-loading-spinner="el-icon-loading"
              :data="payDataList"
            >
              <el-table-column
                width="84"
                prop="id"
                label="订单ID"
              ></el-table-column>
              <el-table-column label="平台订单号">
                <template slot-scope="scope">
                  <el-popover placement="top-start" width="330" trigger="hover">
                    商户订单号：<span
                      class="cursorPointer"
                      @click="CopyTextToClipboard(scope.row.appOrder)"
                    >
                      {{ scope.row.appOrder }}
                      <i class="el-icon-document-copy" /></span
                    ><br />
                    经办人用户名：{{ scope.row.managerUsername }}

                    <span
                      class="cursorPointer"
                      slot="reference"
                      @click="CopyTextToClipboard(scope.row.orderId)"
                    >
                      {{ scope.row.orderId }}
                      <i class="el-icon-document-copy" />
                    </span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                :fixed="checkFixed"
                width="130"
                align="center"
                label="操作"
              >
                <template slot-scope="scope">
                  <el-button
                    style="margin: 2px auto"
                    plain
                    icon="el-icon-s-flag"
                    size="mini"
                    @click="orderCheckEdit(scope.row)"
                  >
                    查单状态
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <pagination
              v-show="payTotal > 0"
              :total="payTotal"
              :page.sync="listQuery.pageNum"
              :limit.sync="listQuery.pageSize"
              @pagination="getList()"
            />
          </el-col>

          <!-- 提现查单列表 -->
          <el-col :span="12">
            <el-tag class="tag-title" size="medium" type="warning" effect="dark"
              >提现</el-tag
            >
            <el-table
              border
              stripe
              ref="table"
              v-loading="withdrawTableLoading"
              element-loading-background="rgba(255, 255, 255, 0.8)"
              element-loading-spinner="el-icon-loading"
              :data="withdrawDataList"
            >
              <el-table-column
                width="84"
                prop="id"
                label="订单ID"
              ></el-table-column>
              <el-table-column label="平台订单号">
                <template slot-scope="scope">
                  <el-popover placement="top-start" width="330" trigger="hover">
                    商户订单号：<span
                      class="cursorPointer"
                      @click="CopyTextToClipboard(scope.row.appOrder)"
                    >
                      {{ scope.row.appOrder }}
                      <i class="el-icon-document-copy" /></span
                    ><br />
                    经办人用户名：{{ scope.row.managerUsername }}

                    <span
                      class="cursorPointer"
                      slot="reference"
                      @click="CopyTextToClipboard(scope.row.orderId)"
                    >
                      {{ scope.row.orderId }}
                      <i class="el-icon-document-copy" />
                    </span>
                  </el-popover>
                </template>
              </el-table-column>

              <el-table-column
                :fixed="checkFixed"
                width="130"
                align="center"
                label="操作"
              >
                <template slot-scope="scope">
                  <el-button
                    style="margin: 2px auto"
                    plain
                    icon="el-icon-s-flag"
                    size="mini"
                    @click="orderCheckEdit(scope.row)"
                  >
                    查单状态
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <pagination
              v-show="withdrawTotal > 0"
              :total="withdrawTotal"
              :page.sync="listQuery.pageNum"
              :limit.sync="listQuery.pageSize"
              @pagination="getList()"
            />
          </el-col>
        </el-row>

        <div style="text-align: right">
          <el-button
            v-if="payDataList.length > 0 || withdrawDataList.length > 0"
            type="success"
            size="small"
            icon="el-icon-document-copy"
            @click="copyAllCheckingOrders()"
            >批量生成查单消息</el-button
          >
        </div>
      </div>
    </el-dialog>

    <!-- 查单状态弹窗 -->
    <OrderCheckEditDialog
      @get-list="getList()"
      :order-check-edit-obj.sync="orderCheckEditObj"
    />
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import varCommon from "@/utils/varCommon";
import { listPayCheckOrders, listWithdrawCheckOrders } from "@/api/checkOrder";
import Pagination from "@/views/components/Pagination";
import OrderCheckEditDialog from "@/views/components/dialog/OrderCheckEditDialog";

export default {
  mixins: [mainCommon],
  props: ["orderCheckObj"],
  components: {
    OrderCheckEditDialog,
    Pagination,
  },
  data() {
    return {
      orderCheckOptions: varCommon.orderCheckOptions,
      orderCheckEditObj: {}, // 修改查单状态数据
      payTableLoading: false,
      payTotal: 0,
      payDataList: [],
      withdrawTableLoading: false,
      withdrawTotal: 0,
      withdrawDataList: [],
      listQuery: {
        pageSize: varCommon.pagination.pageSize,
        pageNum: 1,
        isUnfinished: true,
      },
    };
  },
  watch: {
    orderCheckObj(row) {
      if (row.visible) {
        this.getList();
      }
    },
  },
  methods: {
    // 查单订单复制
    copyAllCheckingOrders() {
      let payOrders = "";
      let withdrawOrders = "";
      this.payDataList.forEach((res) => {
        payOrders += res.orderId + "\r\n";
      });
      this.withdrawDataList.forEach((res) => {
        withdrawOrders += res.orderId + "\r\n";
      });
      this.CopyTextToClipboard(
        `卡主号：${this.orderCheckObj.username}\r\n银行卡：${
          this.orderCheckObj.bankCardNumber
        }\r\n${payOrders ? `收款查单单号：\r\n${payOrders}` : ""}${
          withdrawOrders ? `\r\n出款查单单号：\r\n${withdrawOrders}` : ""
        }`,
        "复制完成"
      );
    },
    // 修改查单状态
    orderCheckEdit(row) {
      this.orderCheckEditObj = {
        visible: true,
        id: row.id,
        remark: row.remark,
        orderId: row.orderId,
        checkStatus: row.checkStatus,
      };
    },
    HandleCancel() {
      this.payTotal = 0;
      this.payDataList = [];
      this.withdrawTotal = 0;
      this.withdrawDataList = [];
      this.$emit("update:order-check-obj", { visible: false });
    },
    // 查单状态 el-tag 类型
    getCheckOrderTagType(row) {
      switch (row) {
        case 0:
          return "warning";
        case 1:
          return "success";
        case 2:
          return "danger";
      }
    },
    // 取得查单状态
    getCheckOrderType(row) {
      return this.orderCheckOptions.find((item) => item.value === row).label;
    },
    getList() {
      this.listQuery.accId = this.orderCheckObj.id;

      this.payTableLoading = true;
      this.withdrawTableLoading = true;
      listPayCheckOrders(this.ObjectClean(this.listQuery))
        .then((res) => {
          this.payTotal = res.data.total;
          this.payDataList = res.data.list;
        })
        .finally(() => {
          this.payTableLoading = false;
        });
      listWithdrawCheckOrders(this.ObjectClean(this.listQuery))
        .then((res) => {
          this.withdrawTotal = res.data.total;
          this.withdrawDataList = res.data.list;
        })
        .finally(() => {
          this.withdrawTableLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.tag-title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/components/dialog/OrderCheckDialog.vue